var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 61.708 63.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(-689 -408)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RTP_icon",
    "data-name": "RTP icon",
    transform: "translate(689 408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M1634.593,154.787a2.773,2.773,0,0,1-2.772-2.737l-.287-22.5-13.672-7.453a2.773,2.773,0,0,1,.178-4.958L1674.2,91.553a2.773,2.773,0,0,1,3.894,2.915l-7.247,50.727a2.773,2.773,0,0,1-4.021,2.069l-19.509-10.119L1636.934,153.5A2.773,2.773,0,0,1,1634.593,154.787Zm2.483-25.524.17,13.4,7.329-11.543c.036-.057.075-.113.115-.167l12.543-16.885Zm13.36,3.253,15.475,8.027,5.1-35.73Zm-25.047-12.629,8.654,4.717,29.037-21.891Z",
    transform: "translate(-1616.416 -91.303)",
    fill: "#385CAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M1669.19,254.771a2.773,2.773,0,0,1-1.548-5.075l20.642-13.864a2.773,2.773,0,1,1,3.092,4.6L1670.734,254.3A2.761,2.761,0,0,1,1669.19,254.771Z",
    transform: "translate(-1651.011 -190.979)",
    fill: "#385CAD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestIcon);
export default __webpack_public_path__ + "static/media/requestIcon.d4b8a53d9923b908a6d01c7c82b4289c.svg";
export { ForwardRef as ReactComponent };